import routeIcon from "../assets/images/gis_route.svg";
import { SHIPMENT_SCOPE } from "../util/quotationUtil";
import { useFieldArray } from "react-hook-form";
import { Cargo, Container } from "../enquiry/enquiry-data";
import { AgMuiUn } from "../mui-components/AgAutoComplete";
import LabeledTextField from "../mui-components/LabeledTextField";
import { Add } from "@mui/icons-material";
import deleteicon from "../assets/images/deletei.svg";
import { ControlledDetailSwitch } from "../v3-componets/AgControlledDetailSwitch";
import { LabeledRadioButton } from "../v3-componets/AgLabeledRadioButton";
import RoleUtils from "../util/RoleUtils";
import { AgmodalStore, filtersState, quoteDataRec } from "../state/CommonState";
import { useSnapshot } from "valtio";
import { useEffect, useState } from "react";
import { PERMISSIONS, PERMISSIONS_NEW } from "../util/constants";
import { useGlobalState } from "../GlobalState";
import { taskStore } from "./task-store";
export function AgRoute({ form, viewonly = false, validateAddress = true, callback = (f) => f, enableCrn = false, currentShipmentScopes = [], scopeView = true }) {
    useSnapshot(AgmodalStore)
    useSnapshot(quoteDataRec)
    let shipmentScopes
    if (currentShipmentScopes.length > 0) {
        shipmentScopes = currentShipmentScopes
    } else {
        shipmentScopes = []
    }
    const { control, watch, register, setValue, handleSubmit, reset, resetField, clearErrors, formState, trigger, getFieldState, getValues } = form;
    const { fields: multidest, append: appendMulitdest, remove: removeMultidest } = useFieldArray({
        control: control,
        name: "multidest"
    })
    const shipmentType = watch("mode");
    const Scope = watch("scope")
    const isFba = watch("isFba");
    const fbaalways = watch("fbaalways");
    const stuffing = watch("stuffingType");
    const deStuffing = watch("destuffingType");
    const outGuage = watch("showCargoDetailsOutGuage")
    const multidestvalue = getValues("multidest") ? getValues("multidest") : watch("multidest")
    const [destcountry, setDestcountry] = useState("")
    useEffect(() => {
        if (multidestvalue != undefined && multidestvalue?.length > 0) {
            setDestcountry(multidestvalue[0]?.destination)
        }
    }, [JSON.stringify(multidestvalue)])
    const { currentMenu } = useGlobalState();
    let showCargoDetail = false;
    let destination = Scope?.split("-")[2];
    if (destination?.toLowerCase() === "door") {
        if ((shipmentType.toLowerCase() === "fcl" && deStuffing.toLowerCase() === "dock") || shipmentType.toLowerCase() != "fcl") {
            showCargoDetail = true;
        }
    } else {
        if (showCargoDetail) showCargoDetail = false;
    }
    const validateGreaterThanZero = (value) => {
        return (value != undefined && value.length != 0) || 'Required';
    };
    const [crn, setCrn] = useState(false)
    useEffect(() => {
        if (!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_CUST_REF_NUMBER)) {
            if (!crn) {
                setCrn(true)
            }
        }
        if ((currentMenu == "Quotationv3" || currentMenu == "Enquiriesv3" || currentMenu == "Spot Booking WIP" || currentMenu=="Carting Sheet") && crn) {
            setCrn(false)
        }
        if (!crn && AgmodalStore.modalPage == 'ViewEnquiry-v3') {
            setCrn(true)
        }
        if (enableCrn) {
            setCrn(false)
        }
    }, [AgmodalStore])


    return <div className="flex flex-col min-h-[304px] w-[431px]">
        <div className="flex flex-col min-h-[304px] max-h-max w-full rounded-md bg-white shadow-custom p-[18px] gap-[16px]">
            <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-[10px]">
                    <img src={routeIcon} />
                    <p className="text-black font-bold">Route</p>
                </div>
                {((fbaalways != undefined && fbaalways == 'Yes') || ((shipmentType === "LCL" || shipmentType.toLowerCase().indexOf("fcl") != -1) && (Scope === "Port-to-Door" || Scope === "Door-to-Door"))) &&
                    <ControlledDetailSwitch control={control} isChecked={isFba} formKey="isFba" title="FBA" disable={viewonly} onChange={() => {
                        filtersState.initialize();
                        setValue("multidest", [
                            {
                                destination: "",
                                cargoDetails: [new Cargo()],
                            }
                        ]);
                        setValue("containerDetails", [new Container()])
                    }} />}
            </div>
            {shipmentScopes.length == 0 || (quoteDataRec.quotationNum !== "" && taskStore.current.actionName == '') ? <div className="flex flex-row gap-2">
                <p className="text-blue-light font-bold font-roboto">{shipmentType}</p>
                <p className="text-blue-dark font-bold font-roboto">-</p>
                <p className="text-blue-dark font-bold font-roboto"> {Scope}</p>
            </div> : <div className="grid grid-cols-2  h-[67px] place-content-stretch">
                {shipmentScopes.map((scope) => <LabeledRadioButton label={scope} selected={Scope === scope} onClick={() => {
                    filtersState.initialize();
                    if (!viewonly) {
                        let s = Scope?.split('-to-')
                        let s1 = scope?.split('-to-')
                        if (s[0] != s1[0]) {
                            setValue("origin", "");
                        }
                        if (s[1] != s1[1]) {
                            let m = JSON.parse(JSON.stringify([multidest[0]]))
                            m[0]['destination'] = ""
                            if ((shipmentType.toLowerCase() == 'lcl' && ((Scope.indexOf('Door') != -1 && scope.indexOf('Door') == -1) || (Scope.indexOf('Door') == -1 && scope.indexOf('Door') != -1))) ||
                                (shipmentType.toLowerCase() == 'fcl' && ((stuffing != 'Factory' && s[0] == s1[0] && s[0] != 'Door') || (deStuffing != 'Factory' && s[1] == s1[1] && s[1] != 'Door') || scope == 'Port-to-Port'))) {
                                m[0]['cargoDetails'] = [new Cargo()]
                            }
                            setValue("multidest", m);
                        }
                        if (shipmentType.toLowerCase() != 'fcl') {
                            setValue("containerDetails", [new Container()])
                        }
                        setValue("scope", "");
                        // setValue("stuffingType","Factory")
                        // setValue("destuffingType","Factory")
                        if (fbaalways == 'No' && isFba) {
                            setValue("isFba", false)
                        }
                        setTimeout(() => {
                            setValue("scope", scope);
                        }, 1)
                        clearErrors();
                    }

                }} />)}
            </div>}
            {multidest.length > 1 && <p className="text-blue-light font-bold">Origin Details</p>}
            <div className="flex flex-col w-full gap-[4px]">
                <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>{!viewonly && "Select"} Origin *</p>
                <AgMuiUn onChange={async () => {
                    filtersState.initialize();
                    await trigger([`origin`]);
                }} getValues={getValues} clearErrors={clearErrors} trigger={trigger} validateAddress={validateAddress} getFieldState={getFieldState} placeholder="Choose Origin" key={"origin"} rules={{ required: "Origin is Required" }} isDoor={Scope === SHIPMENT_SCOPE.D2D || Scope === SHIPMENT_SCOPE.D2P} control={control} name="origin" disabled={true} />
            </div>
            {multidest.length > 1 && <p className="text-blue-light font-bold">Destination Details</p>}
            {multidest.map((m, i) => {
                return <div className="flex flex-col w-full gap-[4px]">
                    {
                        (multidest.length > 1) ? <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>{!viewonly && "Select"} Destination {i + 1} *</p> : <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Select Destination *</p>
                    }

                    <div className="flex flex-col w-full gap-[4px]">
                        <div className="flex flex-row justify-between items-center"><AgMuiUn onChange={() => {
                            filtersState.initialize();
                        }} id={i} getValues={getValues} clearErrors={clearErrors} trigger={trigger} getFieldState={getFieldState} validateAddress={validateAddress} placeholder={isFba ? "Enter Amazon Warehouse Code" : "Choose Destination"} key={m.id} rules={{ required: "Destination is Required" }} isDoor={Scope === SHIPMENT_SCOPE.D2D || Scope === SHIPMENT_SCOPE.P2D} control={control} name={`multidest.${i}.destination`} disabled={viewonly} doorCountry={destcountry} isFba={isFba} />
                            {false && multidest.length > 1 &&
                                <div onClick={() => {
                                    filtersState.initialize();
                                    removeMultidest(i);
                                }} className="w-[35px] h-full flex items-center justify-center cursor-pointer">
                                    <img src={deleteicon} />
                                </div>
                            }
                        </div>
                    </div></div>
            }

            )}
            {
                multidest.length < 5 && showCargoDetail && <div className="flex flex-col w-full gap-[4px]">
                    {false &&
                        <button onClick={() => {
                            filtersState.initialize();
                            let dest = {
                                destination: "",
                                cargoDetails: [new Cargo()],
                            }
                            appendMulitdest({ ...dest });
                        }} type="button" className="bg-[#F7F7F7] border-[1px] border-solid border-[#E8E8E8] h-[35px] rounded-[6px]">
                            <div className="flex h-full w-full flex-row gap-[5px] justify-center items-center font-bold">
                                <Add sx={{ fontSize: "22px", color: process.env.REACT_APP_ENTERPRISE_COLOUR }} />
                                <p className="text-grey">Add Destination</p>
                            </div>
                        </button>}
                </div>
            }

            <div className="grid grid-cols-2 gap-3 h-[67px] place-content-stretch">
                <LabeledTextField labelStyle={{ fontSize: "12px", color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontWeight: "bold" }} label="Cargo Readiness Date" control={control} inputProps={{ min: new Date().toISOString()?.split('T')[0] }} name="cargoreadinessdate" type="date" size="small" fullWidth disabled={true} rules={{ required: "Required", validate: validateGreaterThanZero }} />
                <LabeledTextField labelStyle={{ fontSize: "12px", color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontWeight: "bold" }} label="Customer Reference Number" control={control} name="customerreference" disabled={true} onBlur={(e) => {
                    callback(e)
                }} />
            </div>
        </div>
    </div>
}